<template>
<el-dialog  title="关联账单" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="glzdFlag" width="900px" center>
  <div>
    <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="inpBox box">
          <el-form-item label="账单号:" class="item1">
            <el-input placeholder="" type="textarea" v-model="searchFrom.zdh" class="gjh" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="创建时间:" class="item2">
            <el-date-picker
              v-model="createTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div style="">
          <el-form-item>
            <el-button type="primary" size="mini" @click="getList">查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
          </el-form-item>
          <el-form-item label-width="120px">
            <p class="margin0">已选收入合计:<span class="red">{{yxHejie}}</span>(元)</p>
          </el-form-item>
        </div>
      </el-form>
    <el-table :data="tableList" ref="table" v-loading='loading' class="elTab" highlight-current-row @row-click="dianjixuanzhong" border height="400px" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}" @selection-change='selectGoods'>
        <el-table-column type="selection" width="50" fixed></el-table-column>
        <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
        <el-table-column prop="" label="账单号" align="center" min-width="160">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.billNo" placement="right-end">
              <el-button type="text" @click="detilsYS(scope.row)">{{scope.row.billNo}}</el-button>
              <div slot="content" style="cursor: pointer;" @click="copyBtn(scope.row.billNo)">复制</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="" label="开票状态" align="center"  min-width="100">
          <template scope="scope">
            <!-- 0.未开票、1.开票中.已开票 -->
            <span class="wsStyle" v-show="scope.row.invoicingStates == '0'">未开票</span>
            <span class="bfStyle" v-show="scope.row.invoicingStates == '1'">开票中</span>
            <span class="ysStyle" v-show="scope.row.invoicingStates == '2'">已开票</span>
          </template>
        </el-table-column>
        <el-table-column prop="wayNumber" label="运单数量" align="center"  min-width="90">
        </el-table-column>
        <el-table-column prop="totalAmount" label="收入合计(元)" align="center"  min-width="120">
        </el-table-column>
        <!-- <el-table-column prop="noInvoiceAmount" label="待申请开票金额(元)" align="center" width="150">
        </el-table-column> -->
        <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间"  min-width="170"></el-table-column>
      </el-table>
       <!-- 点击账单号 -->
        <yingShouDetil v-if="yingShouDetilsMark" :yingShouDetilsMark.sync='yingShouDetilsMark'
          :ysSettlementBillId = 'ysSettlementBillId'></yingShouDetil>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="saveFn()">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
import { getSettlementBillList, invoiceApplyAddYsBillList } from '@/api/newTMS'
import { toFixed, dateTimeFormat } from '@/utils/util'
import yingShouDetil from '@/views/newTMS/publicFiles/caiWuYingShou/yingShouDetil.vue'
export default {
  name: 'wzdkp',
  components: {
    yingShouDetil
  },
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    glzdFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      searchFrom: {
        insideOutsideType: 1,
        paymentFlag: 0,
        payer: this.rowData.payer,
        invoicingStates: 0,
        pageNo: 1, // 页数
        pageSize: 500 // 条数
      },
      createTime: [],
      tableList: [],
      yxHejie: 0,
      loading: false,
      yingShouDetilsMark: false,
      ysSettlementBillId: ''
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.getList()
  },
  methods: {
    // 点击账单号
    detilsYS (row) {
      this.yingShouDetilsMark = true
      this.ysSettlementBillId = row.id
    },
    saveFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要关联的账单', '系统提示')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      invoiceApplyAddYsBillList({
        id: this.rowData.id,
        billIds: selectData.map(itme => itme.id).toString(),
        revenueAmount: this.yxHejie
      }).then(res => {
        this.$parent.searchFn()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.$emit('update:glzdFlag', false)
        loading.close()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 复制
    copyBtn (message) {
      // navigator.clipboard.writeText 该方法需要在安全域下才能够使用，比如：https 协议的地址、127.0.0.1、localhost
      navigator.clipboard
        .writeText(message)
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch((err) => {
        // 复制失败
          console.error('复制失败')
        })
    },
    // 选择数据
    selectGoods (selection) {
      this.yxHejie = 0
      selection.forEach((item, index) => {
        this.yxHejie += item.totalAmount
      })
      this.yxHejie = toFixed(this.yxHejie, 2)
    },
    // 获取列表
    getList () {
      this.loading = true
      if (this.createTime) {
        if (this.createTime.length > 0) {
          this.$set(this.searchFrom, 'createTime', this.createTime)
        }
      } else {
        this.$set(this.searchFrom, 'createTime', null)
      }
      if (this.searchFrom.zdh) {
        let zdh = this.searchFrom.zdh.replace(/\n/g, ',')
        let zdhArr = zdh.split(',')
        if (zdhArr.length == 1) {
          this.searchFrom.billNo = zdhArr[0]
        } else {
          this.searchFrom.billNos = zdhArr
        }
      } else {
        this.searchFrom.billNos = null
        this.searchFrom.billNo = ''
      }
      getSettlementBillList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        insideOutsideType: 1,
        paymentFlag: 0,
        pageNo: 1, // 页数
        pageSize: 500, // 条数
        payer: this.rowData.payer,
        invoicingStates: 0
      }
      this.createTime = []
      this.getList()
    },
    closeDialog () {
      this.$emit('update:glzdFlag', false)
    }
  }

}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
  width: 420px!important;
}
.box{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill,270px);
  grid-auto-flow: row dense;
  .item1{
    grid-row-start: span 2;
  }
  .item2{
    grid-column-start: span 2;
    width: 540px;
  }
}
</style>
